<script setup>
import CallbackRequestTable from '@frontJs/components/tables/CallbackRequestTable.vue';
import DefaultLayout from '@frontJs/layouts/DefaultLayout.vue';
import { Head } from '@inertiajs/vue3';
import TabLayout from '@js/components/tabs/TabLayout.vue';
import PageTitle from '@js/components/titles/PageTitle.vue';
import { useRoute } from '@js/utils/route';
import { h, onMounted, ref } from 'vue';

const { route } = useRoute();

const loading = ref(true);

const data = ref({
    toProcess: 0,
    processed: 0,
});

function updateData() {
    loading.value = true;

    Promise.all([
        axios.post(route('front.postCallbackRequestCount'), {
            toProcess: true,
        }),
        axios.post(route('front.postCallbackRequestCount'), {
            processed: true,
        }),
    ])
        .then(([toProcessCountData, processedCountData]) => {
            data.value.toProcess = toProcessCountData.data.count;
            data.value.processed = processedCountData.data.count;
        })
        .catch((error) => {
            console.error(error);
        })
        .finally(() => {
            loading.value = false;
        });
}

onMounted(() => {
    updateData();
});

defineOptions({ layout: DefaultLayout });
</script>

<template>
    <Head>
        <title>Demandes de rappel - Datakepler</title>
    </Head>

    <PageTitle> Demandes de rappel </PageTitle>

    <TabLayout
        :tabs="{
            toRemind: {
                title: 'À rappeler',
                count: data.toProcess,
                content: h(CallbackRequestTable, {
                    toProcess: true,
                    callback: updateData,
                }),
            },
            recalled: {
                title: 'Rappelées',
                count: data.processed,
                content: h(CallbackRequestTable, {
                    processed: true,
                    callback: updateData,
                }),
            },
        }"
        :loading="loading"
    />
</template>
